import React from 'react';
import PortfolioGrid from './portfolio-grid';
import HeroSection from './hero-section';

export default function Portfolio() {
    return (
        <>
            <HeroSection />
            <PortfolioGrid />
        </>
    );
}